import {
  Component,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  SimpleChanges,
} from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { CalendarView } from 'angular-calendar';
import { Subscription } from 'rxjs';
import { Platform } from '@angular/cdk/platform';
import { SelectButtonModule } from 'primeng/selectbutton';
import { FormsModule } from '@angular/forms';

@Component({
  standalone: true,
  selector: 'app-selector-calendar-mode',
  templateUrl: './selector-calendar-mode.component.html',
  styleUrls: ['./selector-calendar-mode.component.scss'],
  imports: [SelectButtonModule, FormsModule],
})
export class SelectorCalendarModeComponent
  implements OnInit, OnDestroy, OnChanges
{
  @Input('onAction')
  onAction: (config: {
    date?: Date;
    view?: CalendarView;
    retrieve: { appointments: boolean; notes: boolean };
  }) => void;

  public calendarModeSelector: { name: any; code: any }[] = [];

  @Input('selected')
  public selected: { name: any; code: any };
  public subscriptionTranslate: Subscription;

  constructor(
    private platform: Platform,
    private translate: TranslateService
  ) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['selected']) {
      this.selected = this.calendarModeSelector.find(
        (x) => x.code === changes['selected'].currentValue.code
      );
    }
  }

  public setDefaultCalendarMode() {
    const viewMode =
      this.platform.ANDROID || this.platform.IOS
        ? CalendarView.Month
        : CalendarView.Week;

    this.selected = this.calendarModeSelector.find((x) => x.code === viewMode);
  }

  public setCalendarModeOptions() {
    this.calendarModeSelector = [
      {
        name: this.translate.instant('COMMON.MONTH'),
        code: CalendarView.Month,
      },
      { name: this.translate.instant('COMMON.WEEK'), code: CalendarView.Week },
      { name: this.translate.instant('COMMON.DAY'), code: CalendarView.Day },
    ];
  }

  ngOnDestroy() {
    this.subscriptionTranslate.unsubscribe();
  }

  ngOnInit(): void {
    this.setCalendarModeOptions();
    this.setDefaultCalendarMode();

    this.subscriptionTranslate = this.translate.onLangChange.subscribe(() => {
      this.setCalendarModeOptions();
      if (this.selected) {
        this.selected = this.calendarModeSelector.find(
          (x) => x.code === this.selected.code
        );
      } else {
        this.setDefaultCalendarMode();
      }
    });
  }
}
